import { EventEmitter } from '@angular/core';
import { Component, Input, Output } from '@angular/core';
import { IconNames } from '@shared/enums/icon-names';
import { HardwareVariant } from '../../../models/mobilephone-variant';
import { IceIconButtonComponent } from '@app/shared/components/atoms/ice-icon-button/ice-icon-button.component';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatDialogTitle, MatDialogClose } from '@angular/material/dialog';

@Component({
  selector: 'app-mobilephone-search-header',
  templateUrl: './mobilephone-search-header.component.html',
  styleUrls: ['./mobilephone-search-header.component.scss'],
  imports: [MatDialogTitle, MatIcon, NgClass, IceIconButtonComponent, MatDialogClose],
})
export class MobilephoneSearchHeaderComponent {
  IconNames = IconNames;
  @Input() selectedMobilePhoneVariant: HardwareVariant;
  @Input() searchPageText: string;
  @Input() detailsPageText: string;
  @Input() isManualRegistration: boolean;
  @Output() backToMobileSearch = new EventEmitter();
}
